import { ReactNode, useRef, useState } from "react";
import { navigate } from "gatsby";
import { Drawer, DrawerRef } from "../../drawer";
import { MenuIcon } from "../../icons/MenuIcon";
import { ButtonIcon } from "../../link/ButtonIcon";
import {
  logoContainer,
  menuButtonContainer,
  titleContainer,
  topPanel,
  topPanelContainer,
} from "./styles.css";
import { NavigationPanel, NavigationPanelRef } from "../../navigation-menu";
import { Location } from "../../../../providers/routing/types";
import {
  ABOUT_US_PAGE,
  ADVANCED_TECHNOLOGY_PAGE,
  CUSTOM_DESIGN_PAGE,
  CUTTING_COSTS_PAGE,
  NEWS_PAGE,
  SUSTAINABILITY_PAGE,
} from "../../../../providers/routing/routes";
import { LogoButton } from "./LogoButton";
import { scrollToTop } from "../../../utils/changeSlide";
import { ChangeLanguageButtons } from "./changeLanguage";
import { useBreakpoint } from "gatsby-plugin-breakpoints";

const getCurrentLocation = (): Location => {
  if (typeof window === "undefined") return "main";

  const pathname = window.location.pathname;

  const pathWithoutLang = pathname.includes("/de/")
    ? pathname.replace(/^\/[a-z]{2}(\/|$)/, "/")
    : pathname;

  switch (pathWithoutLang) {
    case ADVANCED_TECHNOLOGY_PAGE:
      return "inner-technology";
    case CUSTOM_DESIGN_PAGE:
      return "inner-custom-design";
    case SUSTAINABILITY_PAGE:
      return "inner-sustainability";
    case CUTTING_COSTS_PAGE:
      return "inner-cutting-costs";
    case ABOUT_US_PAGE:
      return "inner-about-us";
    case NEWS_PAGE:
      return "inner-news";

    default:
      return (window.location.hash.slice(1) || "main") as Location;
  }
};

const goBack = () => {
  navigate(-1);
};

export const TopPanel = ({
  sticky,
  title,
  isModalPage,
}: {
  sticky?: boolean;
  title?: ReactNode;
  isModalPage?: boolean;
}) => {
  const drawerRef = useRef<DrawerRef>(null);
  const navigationPanelRef = useRef<NavigationPanelRef>(null);
  const [isOpen, setIsOpen] = useState(() => drawerRef.current?.isOpen());
  const [isShowToggle, setShowToggle] = useState(isOpen);

  const currentLocation = getCurrentLocation();
  const { isLaptop } = useBreakpoint();

  const handleDrawerOpen = async () => {
    setIsOpen(true);
    await drawerRef.current?.open();
    await navigationPanelRef.current?.open();
    setShowToggle(true);
  };

  const handleDrawerClose = async () => {
    setShowToggle(false);
    await navigationPanelRef.current?.hide();
    await drawerRef.current?.close();
    setIsOpen(false);
  };

  const toggleDrawer = () => {
    drawerRef.current?.isOpen() ? handleDrawerClose() : handleDrawerOpen();
  };

  const handleNavigate = async () => {
    await handleDrawerClose();
  };

  const panelVariant = sticky ? "sticky" : "fixed";

  return (
    <>
      <Drawer drawerRef={drawerRef}>
        <NavigationPanel
          animationRef={navigationPanelRef}
          onNavigate={handleNavigate}
          currentLocation={currentLocation}
        />
      </Drawer>
      <div id="__top-panel" className={topPanelContainer[panelVariant]}>
        <div className={topPanel}>
          <div className={logoContainer}>
            <LogoButton
              onClick={async () => {
                scrollToTop();

                await handleDrawerClose();
              }}
            />
          </div>
          <div className={titleContainer}>{title}</div>

          <div className={menuButtonContainer}>
            {(isLaptop || isShowToggle) && <ChangeLanguageButtons />}
            <ButtonIcon onClick={isModalPage ? goBack : toggleDrawer} primary>
              <MenuIcon isTransformed={isModalPage || isOpen} />
            </ButtonIcon>
          </div>
        </div>
      </div>
    </>
  );
};
